import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';
import { formatCount, formatDate } from '@/utils/format';

export default function WorkCard({ work, featured = false }: { work: Work; featured?: boolean }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300">
      <Link to={`/works/${work.id}`} className="block">
        <div className={`relative w-full overflow-hidden ${featured ? 'h-56 md:h-64' : 'h-44'}`}>
          <img
            src={work.cover}
            alt={`${work.title} - 黑料大赛参赛作品封面`}
            title={`${work.title} - 黑料大赛参赛作品`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 font-label text-xs text-background-50">
            <i className="ri-fire-fill"></i>
            {work.category}
          </span>
          <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 font-label text-xs text-foreground-800">
            热度 {work.heat}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2 flex items-center gap-2 font-label text-xs text-foreground-500">
          <i className="ri-user-3-line"></i>
          <span>{work.contestant}</span>
          <span className="text-foreground-300">·</span>
          <span>{formatDate(work.publishedAt)}</span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/works/${work.id}`} className="transition-colors hover:text-primary-600">
            {work.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 font-body text-sm leading-relaxed text-foreground-600">{work.summary}</p>

        <div className="mt-auto flex items-center justify-between pt-4 font-label text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatCount(work.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-thumb-up-line"></i>
              {formatCount(work.likes)}
            </span>
          </div>
          <Link
            to={`/works/${work.id}`}
            className="flex items-center gap-1 whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
          >
            进入围观
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}